import queryString from "query-string";

import { createApi, createApiV2 } from "./common";

/* MYOB */
export const getMyobConnection = createApi("GET", "myob/authorize");

export const disconnectMyob = createApi("DELETE", "myob/disconnect");

export const registerProfile = createApi("POST", "myob/authenticate_companyfile/");

export const completeMyobAuth = createApi("GET", "myob/complete_authorization");

export const getMyobAccounts = () => (token) => createApiV2("GET", "myob/accounts/")(token);

export const getMyobTaxCodes = () => (token) => createApiV2("GET", "myob/tax_codes/")(token);

export const getMyobItems = () => (token) => createApiV2("GET", "myob/items/")(token);

export const getMyobJobs =
  (params = {}) =>
  (token) => {
    const queryParams = queryString.stringify(params);
    return createApiV2("GET", `myob/jobs/?${queryParams}`)(token);
  };

export const getMyobCustomers = createApiV2("GET", "myob/customers/");

export const getMyobSuppliers = (search) => (token) =>
  createApiV2("GET", "myob/suppliers/")(token, search);

export const getMyobEmployees = (search) => (token) =>
  createApiV2("GET", "myob/employees/")(token, search);

export const getMyobPayRates = () => (token) => createApiV2("GET", "myob/pay_rates/")(token);

export const postMyobJobs = (data) => (token) => createApiV2("POST", "myob/jobs/")(token, data);

export const getMyobActivities = () => (token) => createApiV2("GET", "myob/activities/")(token);

export const getMyobLocations = () => (token) => createApiV2("GET", "myob/locations/")(token);

/* QBO */
export const getQboConnection = createApi("GET", "qbo/authorize");

export const completeQboAuth = createApi("GET", "qbo/complete_authorization");

export const disconnectQbo = createApi("DELETE", "qbo/disconnect");

export const getQboAccounts = () => (token) => createApiV2("GET", "qbo/accounts")(token);

export const getQboTaxCodes = () => (token) => createApiV2("GET", "qbo/taxcodes")(token);

export const getQboItems = () => (token) => createApiV2("GET", "qbo/items")(token);

export const getQboCustomers = createApiV2("GET", "qbo/customers");

export const getQboSuppliers = (search) => (token) =>
  createApiV2("GET", "qbo/suppliers")(token, search);

export const getQboEmployees = (search) => (token) =>
  createApiV2("GET", "qbo/employees")(token, search);

export const getQboPayRates = () => (token) => createApiV2("GET", "qbo/pay_rates/")(token);

/* XERO */
export const getXeroConnection = createApiV2("GET", "xero/authorize");

export const completeXeroAuth = createApiV2("GET", "xero/complete_authorization");

export const disconnectXero = createApiV2("DELETE", "xero/disconnect/");

export const getXeroAccounts = () => (token) => createApiV2("GET", "xero/accounts")(token);

export const getXeroItems = () => (token) => createApiV2("GET", "xero/items/")(token);

export const getXeroCustomers = createApiV2("GET", "xero/customers");

export const getXeroConnectionStatus = () => (token) =>
  createApiV2("GET", "xero/connection_status/")(token);

export const getXeroSuppliers = (search) => (token) =>
  createApiV2("GET", "xero/suppliers")(token, search);

export const getXeroEmployees = (search) => (token) =>
  createApiV2("GET", "xero/employees")(token, search);

export const getXeroTrackingCategories = (search) => (token) =>
  createApiV2("GET", "xero/tracking_categories/")(token, search);

export const getXeroPayRates = () => (token) => createApiV2("GET", "xero/pay_rates/")(token);

/* ACCOUNTING */
export const getPaymentAccounts = () => (token) =>
  createApiV2("GET", "accounting/payment-accounts/")(token);

export const getUpdateAllData =
  (params = {}) =>
  (token) => {
    const queryParams = queryString.stringify(params);
    return createApiV2("GET", `update_all_data/?${queryParams}`)(token);
  };
